import "./Header.css";
import {
  NavDropdown,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import adminMenuItems from "../../../constants/adminMenuItems";

export default function AdminNavMenu(props) {

    return (
            <>
              <NavDropdown.Item
                as={Link}
                to="/admin"
                className="navbar-collapsed-menu-button"
                onClick={props?.toggleNavExpansion}
              >
                Home
              </NavDropdown.Item>
              {adminMenuItems.map((menuItem, idx) => (
                <NavDropdown.Item
                  as={Link}
                  to={menuItem.path}
                  key={idx}
                  className="navbar-collapsed-menu-button"
                  onClick={props?.toggleNavExpansion}
                >
                  {menuItem.label}
                </NavDropdown.Item>
              ))}
              <NavDropdown.Item
                onClick={() => {
                  props.logout();
                  props?.toggleNavExpansion(); }}
                className="navbar-collapsed-menu-button"
              >
                Logout
              </NavDropdown.Item>
            </>
          );
    
}